var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCreditCard = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92D7E7"
    },
    d: "M24,92h432c8.837,0,16,7.163,16,16v264c0,8.837-7.163,16-16,16H24c-8.837,0-16-7.163-16-16V108 C8,99.163,15.163,92,24,92z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF1D25"
    },
    cx: 328,
    cy: 308,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FBB03B"
    },
    cx: 384,
    cy: 308,
    r: 48
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBC17D"
    },
    d: "M72,132h24v32H72V132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C08329"
    },
    d: "M40,164v24c0,4.418,3.582,8,8,8h24v-32H40z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA974D"
    },
    d: "M72,132H48c-4.418,0-8,3.582-8,8v24h32V132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA974D"
    },
    d: "M72,164v32h40c4.418,0,8-3.582,8-8v-24H72z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C08329"
    },
    d: "M112,132H96v32h24v-24C120,135.582,116.418,132,112,132z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456,84H24C10.745,84,0,94.745,0,108v264c0,13.255,10.745,24,24,24h432c13.255,0,24-10.745,24-24V108 C480,94.745,469.255,84,456,84z M464,372c0,4.418-3.582,8-8,8H24c-4.418,0-8-3.582-8-8V108c0-4.418,3.582-8,8-8h432 c4.418,0,8,3.582,8,8V372z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M384,252c-11.453-0.007-22.628,3.522-32,10.104c-25.348-17.721-60.262-11.538-77.983,13.809s-11.538,60.262,13.809,77.983 c19.27,13.472,44.903,13.472,64.173,0c25.348,17.721,60.262,11.538,77.983-13.809c17.721-25.348,11.538-60.262-13.809-77.983 C406.742,255.51,395.508,251.982,384,252z M280,308c-0.051-22.034,17.77-39.937,39.804-39.988c7.096-0.016,14.067,1.86,20.196,5.436 c-16.032,20.245-16.032,48.859,0,69.104c-19.032,11.103-43.461,4.676-54.564-14.356C281.86,322.067,279.984,315.095,280,308z  M384,348c-22.091,0-40-17.909-40-40s17.909-40,40-40s40,17.909,40,40C423.974,330.08,406.08,347.974,384,348z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40,340h64v16H40V340z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120,340h72v16h-72V340z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136,284h104v16H136V284z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M352,220h72v16h-72V220z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M248,220h72v16h-72V220z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144,220h72v16h-72V220z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40,220h72v16H40V220z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M128,188v-48c0-8.837-7.163-16-16-16H48c-8.837,0-16,7.163-16,16v48c0,8.837,7.163,16,16,16h64 C120.837,204,128,196.837,128,188z M112,156h-8v-16h8V156z M80,156v-16h8v16H80z M64,140v16H48v-16H64z M48,172h16v16H48V172z  M80,188v-16h32v16H80z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M344,116h96v16h-96V116z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M376,148h64v16h-64V148z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCreditCard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/creditCard.9ff35605.svg";
export { ForwardRef as ReactComponent };